import { render } from "./InfoPages.vue?vue&type=template&id=49264a4e&scoped=true"
import script from "./InfoPages.vue?vue&type=script&lang=js"
export * from "./InfoPages.vue?vue&type=script&lang=js"

import "./InfoPages.vue?vue&type=style&index=0&id=49264a4e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49264a4e"]])

export default __exports__